import { FC } from 'react';

import CircularProgress from '@material-ui/core/CircularProgress';

import ReasonParagraph from '../ReasonParagraph';
import CopyButton from '../CopyButton';

interface Props {
    loading: boolean;
    reason?: string;
}

const ExplainabilityContent: FC<Props> = ({ loading, reason }) => {
    return (
        <div className="w-full h-full flex flex-col gap-3 relative overflow-y-auto">
            {reason && (
                <div className="absolute right-2 top-2">
                    <CopyButton copyContent={reason} />
                </div>
            )}
            {loading ? (
                <div className="h-fit w-fit self-center justify-self-center">
                    <CircularProgress />
                </div>
            ) : (
                <ReasonParagraph reasonParagraph={reason ?? 'No reason found'} />
            )}
        </div>
    );
};

export default ExplainabilityContent;
